import { ApiService } from './api/api'

export default class OperatorService {
	private apiService

	constructor() {
		this.apiService = new ApiService(false, '2')
	}

	/**
	 * Get all operators at a depot
	 * @param depot string
	 * @returns Promise
	 */
	getAllByDepot(depot: string): Promise<any> {
		return this.apiService.get(`/operator/${depot}`)
	}
}
